module.exports = {
  Bing: require('./bing'),
  Google: require('./google'),
  Mapbox: require('./mapbox'),
  Wikidata: require('./wikidata')
}



/*****************
 ** WEBPACK FOOTER
 ** ./~/geocoder-geojson/providers/index.js
 ** module id = 748
 ** module chunks = 0
 **/